import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=669d2412&scoped=true&"
import script from "./BaseSlider.vue?vue&type=script&lang=ts&"
export * from "./BaseSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSlider.vue?vue&type=style&index=0&id=669d2412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d2412",
  null
  
)

export default component.exports